import classNames from "classnames";
import React from "react";
import useTextColor from "../_colors/useTextColor";
import * as s from "./s.module.scss"


export const HeadingType = {
  H1: "H1",
  H2: "H2",
  H3: "H3",
  H4: "H4",
  H5: "H5",
  H6: "H6",
  values() {
    const types = { ...this };
    delete types.values;
    return Object.keys(types).map(list => HeadingType[list]);
  }
};

export const WeightType = {
  REGULAR: "REGULAR",
  SEMIBOLD: "SEMIBOLD",
  BOLD: "BOLD",
  EXTRABOLD: "EXTRABOLD",
  values() {
    const types = { ...this };
    delete types.values;
    return Object.keys(types).map(list => WeightType[list]);
  }
};

function Heading(props) {
  const {
    type,
    size,
    weight,
    children,
    uppercase,
    lowercase,
    left,
    right,
    center,
    className,
    color,
    ...rest
  } = props;

  const textColor = useTextColor(color);

  const weightTypes = {
    [s.fontWeightRegular]: weight === WeightType.REGULAR,
    [s.fontWeightSemiBold]: weight === WeightType.SEMIBOLD,
    [s.fontWeightBold]: weight === WeightType.BOLD,
    [s.fontWeightExtraBold]: weight === WeightType.EXTRABOLD
  };

  const headingSize = {
    [s.h1]: size === "h1",
    [s.h2]: size === "h2",
    [s.h3]: size === "h3",
    [s.h4]: size === "h4",
    [s.h5]: size === "h5",
    [s.p]: size === "p"
  };

  const textUppercase = {
    [s.textUppercase]: uppercase
  };

  const textLowercase = {
    [s.textLowercase]: lowercase
  };

  const textLeft = {
    [s.textLeft]: left
  };

  const textRight = {
    [s.textRight]: right
  };

  const textCenter = {
    [s.textCenter]: center
  };

  let heading;

  switch (type) {
    case HeadingType.H1:
      heading = (
        <h1
          className={classNames(
            headingSize,
            weightTypes,
            textUppercase,
            textLowercase,
            textLeft,
            textRight,
            textCenter,
            textColor,
            className
          )}
          {...rest}
        >
          {children}
        </h1>
      );
      break;
    case HeadingType.H2:
      heading = (
        <h2
          className={classNames(
            headingSize,
            weightTypes,
            textUppercase,
            textLowercase,
            textLeft,
            textRight,
            textCenter,
            textColor,
            className
          )}
          {...rest}
        >
          {children}
        </h2>
      );
      break;
    case HeadingType.H3:
      heading = (
        <h3
          className={classNames(
            headingSize,
            weightTypes,
            textUppercase,
            textLowercase,
            textLeft,
            textRight,
            textCenter,
            textColor,
            className
          )}
          {...rest}
        >
          {children}
        </h3>
      );
      break;
    case HeadingType.H4:
      heading = (
        <h4
          className={classNames(
            headingSize,
            weightTypes,
            textUppercase,
            textLowercase,
            textLeft,
            textRight,
            textCenter,
            textColor,
            className
          )}
          {...rest}
        >
          {children}
        </h4>
      );
      break;
    case HeadingType.H5:
      heading = (
        <h5
          className={classNames(
            headingSize,
            weightTypes,
            textUppercase,
            textLowercase,
            textLeft,
            textRight,
            textCenter,
            textColor,
            className
          )}
          {...rest}
        >
          {children}
        </h5>
      );
      break;
    case HeadingType.H6:
      heading = (
        <h6
          className={classNames(
            headingSize,
            weightTypes,
            textUppercase,
            textLowercase,
            textLeft,
            textRight,
            textCenter,
            textColor,
            className
          )}
          {...rest}
        >
          {children}
        </h6>
      );
      break;
    default:
      heading = (
        <h6
          className={classNames(
            headingSize,
            weightTypes,
            textUppercase,
            textLowercase,
            textLeft,
            textRight,
            textCenter,
            textColor,
            className
          )}
          {...rest}
        >
          {children}
        </h6>
      );
  }
  return heading;
}

export default Heading;
